import { render, staticRenderFns } from "./retailcoupon.vue?vue&type=template&id=67f4d920&scoped=true"
import script from "./retailcoupon.vue?vue&type=script&lang=js"
export * from "./retailcoupon.vue?vue&type=script&lang=js"
import style0 from "./retailcoupon.vue?vue&type=style&index=0&id=67f4d920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f4d920",
  null
  
)

export default component.exports